import React, { useState } from 'react';
import OrderDetailsStepper from '../../../../../../components/OrderDetailsStepper/OrderDetailsStepper';
import FulfilmentSchedule from '../../AdditionalDetails/FulfilmentSchedule';
import PickUpDeliveryDetails from '../../AdditionalDetails/PickUp&DeliveryDetails';
import BaseOrderDetails from '../../../../../../components/BaseOrderDetails/BaseOrderDetails';
import TruckDetailsMap from '../../AdditionalDetails/TruckDetailsMap';
import { AdminOrderProps } from '../../../adminOrder.interface';
import OrderContractDetails from '../../../../../../components/OrderContractDetails/OrderContractDetails';

const FillerStep: React.FC<AdminOrderProps> = (props) => {
	const {
		selectedOrder,
		currentStep,
		isFinalStep = false,
		contract,
		hideMap,
	} = props;
	const [stepperMargin, setStepperMargin] = useState<number>(0);

	const handleWidthChange = (value: number) => {
		setStepperMargin(value);
	};

	const showTruckMap = currentStep! >= 4 && currentStep! <= 8 && !hideMap;

	const renderInitialSection = () => {
		return currentStep === 6 || currentStep === 10 ? (
			<PickUpDeliveryDetails
				selectedOrder={selectedOrder}
				target={selectedOrder?.target}
				isPickUp={true}
				simpleOrder={selectedOrder?.trucks?.length === 1}
			/>
		) : (
			<FulfilmentSchedule
				selectedOrder={selectedOrder}
				step={currentStep!}
				deliveryIncluded={selectedOrder?.deliveryIncluded!}
				simpleOrder={selectedOrder?.trucks?.length === 1}
			/>
		);
	};

	return (
		<>
			<div style={{ marginBottom: `${stepperMargin}px` }}>
				<OrderDetailsStepper
					current={currentStep!}
					simpleOrder={selectedOrder?.trucks?.length === 1}
					order={selectedOrder}
					onWidthChange={handleWidthChange}
					isFinalStep={isFinalStep}
				/>
			</div>

			<div className="px-10 pt-7 pb-3.5">
				{contract ? (
					<OrderContractDetails
						selectedOrder={selectedOrder}
						contract={contract}
						target="admin"
					/>
				) : showTruckMap ? (
					<TruckDetailsMap selectedOrder={selectedOrder} />
				) : (
					renderInitialSection()
				)}
			</div>

			{contract && showTruckMap ? (
				<div className="px-10 py-3.5">
					<TruckDetailsMap selectedOrder={selectedOrder} />
				</div>
			) : null}

			{contract ? (
				<div className="px-10 py-3.5">{renderInitialSection()}</div>
			) : showTruckMap ? (
				<div className="px-10 py-3.5">{renderInitialSection()}</div>
			) : null}

			<div className="px-10 py-3.5">
				{currentStep === 6 ? (
					<FulfilmentSchedule
						selectedOrder={selectedOrder}
						step={currentStep}
						deliveryIncluded={selectedOrder?.deliveryIncluded!}
						simpleOrder={selectedOrder?.trucks?.length === 1}
					/>
				) : currentStep! < 6 ? (
					<PickUpDeliveryDetails
						selectedOrder={selectedOrder}
						target={selectedOrder?.target}
						isPickUp={true}
						simpleOrder={selectedOrder?.trucks?.length === 1}
					/>
				) : currentStep === 10 ? (
					<FulfilmentSchedule
						selectedOrder={selectedOrder}
						step={currentStep}
						deliveryIncluded={selectedOrder?.deliveryIncluded!}
						simpleOrder={selectedOrder?.trucks?.length === 1}
					/>
				) : (
					<PickUpDeliveryDetails
						selectedOrder={selectedOrder}
						target={selectedOrder?.target}
						isPickUp={true}
						simpleOrder={selectedOrder?.trucks?.length === 1}
					/>
				)}
			</div>

			<div className="px-10 py-3.5">
				<PickUpDeliveryDetails
					selectedOrder={selectedOrder}
					target={selectedOrder?.target}
					isPickUp={false}
					simpleOrder={selectedOrder?.trucks?.length === 1}
				/>
			</div>

			<div className="px-10 pb-7 pt-3.5">
				<BaseOrderDetails
					selectedOrder={selectedOrder}
					isOpen={true}
					simpleOrder={selectedOrder?.trucks?.length === 1}
					deliveryIncluded={selectedOrder?.deliveryIncluded!}
					target={selectedOrder?.target!}
					contract={contract}
				/>
			</div>
		</>
	);
};

export default FillerStep;
